import React from 'react';
import { AppRoutes } from './pages/routes';

function App() {
  return (
    <AppRoutes />
  );
}

export default App;
